module.exports = __webpack_public_path__ + "static/junior-4-5b755398aa49283deaa84e8dd5bdb2ab.png";